const ListTypes = `
  id
  name
`;

export default ListTypes;
